<template>
    <div>
        <h1>Authorization Code</h1>
        <p v-if="code">Authorization code: {{ code }}</p>
        <p v-else>No authorization code received.</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            code: null
        };
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.code = urlParams.get('code');
        if (this.code) {
            // Manejar el código de verificación aquí
            // console.log('Authorization code:', this.code);
            // Puedes almacenar el código en el estado de la aplicación o hacer una solicitud a tu backend
        }
    }
};
</script>